import moment from 'moment'

export default loan => {
  const [prediction] = loan.predictionResults.slice()
    .filter(result => result.predictionModel.type === 'default')
    .sort((a, b) => moment(b.createdAt).unix() - moment(a.createdAt).unix());

  return prediction ? prediction.riskRating : null
}
